// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * OrganisationSchema - Implements schema.org Website
  *
  * Describes a webpage
  *
  * @example
    <OrganisationSchema data={data}>
  *
  * @param {string} data.name - Name of the organisation
  * @param {string} data.legalName - Legal name or the organisation
  * @param {string} data.url - Homepage of the organisation
  * @param {string} data.logo - Logo
  * @param {string} data.foundingDate - Date the organisation was founded
  * @param {array} data.founders - A list of founding members
  * @param {string} data.streetAddress - Street address of the head office
  * @param {string} data.addressLocality - Locality of the head office
  * @param {string} data.addressRegion - Region of the organisation
  * @param {string} data.postalCode - Postal code of the region
  * @param {string} data.addressCountry - Country of the organisation
  * @param {array} data.telephone - Array of telephone numbers
  * @param {string} data.email - Email of the organisation
  * @param {array} data.sameAs - Social accounts of the organisation
  * @param {string} data.image - Required. A unique banner image.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/WebSite|Schema.org Webpage Docs}
  */
var OrganisationSchema = function OrganisationSchema(props) {
  var data = props.data;


  var sanitized = data.url;
  if (sanitized.endsWith("/")) {
    sanitized = sanitized.substring(0, sanitized.length - 1);
  }

  var schemaOrgJSONLD = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: data.name,
    legalName: data.legalName,
    url: sanitized,
    logo: data.logo,
    foundingDate: data.foundingDate,
    founders: data.founders.map(function (founder) {
      return {
        "@type": "Person",
        name: founder
      };
    }),
    address: {
      "@type": "PostalAddress",
      streetAddress: data.streetAddress,
      addressLocality: data.addressLocality,
      addressRegion: data.addressRegion,
      postalCode: data.postalCode,
      addressCountry: data.addressCountry
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: data.telephone,
      email: data.email
    },
    sameAs: data.sameAs,
    image: data.image
  };

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      "script",
      { type: "application/ld+json" },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

OrganisationSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

OrganisationSchema.defaultProps = {
  data: {}
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default OrganisationSchema;